import { RefObject } from "react";
import { View } from "react-native";
import { Text } from "react-native-paper";
import HTMLDisplay from "../../components/HTMLDisplay";
import { ContentSectionProps } from "./ContentSection";
import { formatTotalCompensation, formatCompensation } from "../utils";
import { Job } from "./types";

interface PaySectionProps extends ContentSectionProps {
  job: Job;
  paySectionRef: RefObject<View>;
}

const PaySection = ({ title, job, content, paySectionRef }: PaySectionProps) => {
  const shouldHidePaySection = job.hide_compensation_from_job_board;
  return (
    <View ref={paySectionRef} className="flex border-t border-sky-light px-6 py-8">
      <Text className="mb-6 text-title-5 font-700 text-ink-darkest">{title}</Text>
      {!shouldHidePaySection && (
        <>
          <Text className="mb-2 text-regular-normal font-700 text-ink">Salary:</Text>
          <Text className="mb-6 text-regular-normal font-400 text-ink">{formatCompensation(job)}</Text>
        </>
      )}
      <Text className="-mb-1 text-regular-normal font-700 text-ink">Additional Income:</Text>
      <HTMLDisplay html={content} />
      {!shouldHidePaySection && (
        <>
          <Text className="mb-2 mt-4 text-regular-normal font-700 text-ink">Total anticipated compensation up to:</Text>
          <Text className="text-regular-normal font-400 text-ink">{formatTotalCompensation(job)}</Text>
        </>
      )}
    </View>
  );
};

export default PaySection;
